import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import PrintIcon from '@mui/icons-material/Print'
import RefreshIcon from '@mui/icons-material/Refresh'
import SaveIcon from '@mui/icons-material/Save'
import SearchIcon from '@mui/icons-material/Search'

type MuiIcon = typeof AddIcon

export type ButtonMuiIconOption = {
  name: string
  label: string
  Icon: MuiIcon
}

/** Curated MUI icons for CommandBar buttons (designer picker + runtime resolve). */
export const BUTTON_MUI_ICONS: ButtonMuiIconOption[] = [
  { name: 'Add', label: 'Add', Icon: AddIcon },
  { name: 'EditOutlined', label: 'Edit', Icon: EditOutlinedIcon },
  { name: 'DeleteOutline', label: 'Delete', Icon: DeleteOutlineIcon },
  { name: 'Save', label: 'Save', Icon: SaveIcon },
  { name: 'Close', label: 'Close', Icon: CloseIcon },
  { name: 'Search', label: 'Search', Icon: SearchIcon },
  { name: 'Refresh', label: 'Refresh', Icon: RefreshIcon },
  { name: 'Print', label: 'Print', Icon: PrintIcon },
  { name: 'OpenInNew', label: 'Open', Icon: OpenInNewIcon },
]

const ICON_BY_NAME = new Map(BUTTON_MUI_ICONS.map((o) => [o.name, o.Icon]))

export function resolveMuiIcon(name: string | undefined): MuiIcon | null {
  if (!name?.trim()) return null
  return ICON_BY_NAME.get(name.trim()) ?? null
}
